import React from 'react';
import HomeIcon from '@mui/icons-material/Home';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import FlightLandIcon from '@mui/icons-material/FlightLand';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

const TrajetDisplay = ({ trajet }) => {
  const containerStyle = "flex align-items-center gap-2 font-medium text-800";
  const iconStyle = { color: '#4b5563', fontSize: '1.5rem' };

  if (trajet?.includes("Aéroport Roland-Garros (RUN)") && trajet?.startsWith("Depuis mon domicile")) {
    return (
      <div className={containerStyle}>
        <HomeIcon sx={iconStyle} />
        <span>Domicile</span>
        <ArrowRightAltIcon sx={{ color: '#4b5563' }} />
        <FlightTakeoffIcon sx={iconStyle} />
        <span>Aéroport</span>
      </div>
    );
  }

  if (trajet?.includes("Aéroport Roland-Garros (RUN)") && trajet?.startsWith("De l'Aéroport")) {
    return (
      <div className={containerStyle}>
        <FlightLandIcon sx={iconStyle} />
        <span>Aéroport</span>
        <ArrowRightAltIcon sx={{ color: '#4b5563' }} />
        <HomeIcon sx={iconStyle} />
        <span>Domicile</span>
      </div>
    );
  }

  return <span className="text-sm">{trajet}</span>;
};

export default TrajetDisplay;